var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "icon-pass_svg__a",
  width: 32,
  height: 32,
  x: 8,
  y: 8,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8 8h32v32H8z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon-pass_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.062 10.398c-4.046 0-6.662 2.773-6.662 7.066v13.069c0 4.293 2.616 7.066 6.662 7.066h13.87c4.05 0 6.668-2.773 6.668-7.066V17.464c0-4.293-2.617-7.066-6.666-7.066zM30.932 40h-13.87C11.642 40 8 36.195 8 30.535v-13.07C8 11.806 11.642 8 17.062 8h13.872C36.358 8 40 11.805 40 17.466v13.069C40 36.195 36.357 40 30.931 40Z",
  clipRule: "evenodd"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.942 22.237A1.764 1.764 0 1 0 20.702 24c0-.971-.79-1.762-1.76-1.763m-.003 5.926A4.17 4.17 0 0 1 14.776 24a4.167 4.167 0 0 1 4.163-4.163A4.167 4.167 0 0 1 23.102 24a4.17 4.17 0 0 1-4.163 4.163",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.016 28.164a1.2 1.2 0 0 1-1.2-1.2v-1.765h-8.909a1.2 1.2 0 1 1 0-2.4h10.109a1.2 1.2 0 0 1 1.2 1.2v2.965a1.2 1.2 0 0 1-1.2 1.2",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.49 28.164a1.2 1.2 0 0 1-1.2-1.2v-2.965a1.2 1.2 0 0 1 2.4 0v2.965a1.2 1.2 0 0 1-1.2 1.2",
  clipRule: "evenodd"
})));
export default SvgIconPass;